<h2>About</h2>
<h3>Name: Morris Anthony</h3>
<p>
  This project is a part of my WEB422 assignment. It involves a basic Angular
  App which uses Static Spotify data for rendering.
</p>
